import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { OperationPorteurSearch } from '@/models/operationssearch.model'
import { FileToDownload } from '@/models/user.model'

export default {
  data () {
    return {
      loading: false,
      listeRapports: [],
      formatReleve: ['Bureautique', 'Fixe'],
      rechercheOperationPorteur: new OperationPorteurSearch(),
      fileToDownload: new FileToDownload()
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  computed: {
    // Carte active dans le store
    currentCard () {
      return this.$store.state.user.actualSelectedCard
    }
  },
  watch: {
    // Déclenché à chaque changement de carte dans BlocAuthenticated
    currentCard (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.loadRelevesOperations()
      }
    }
  },
  methods: {
    async getFileOperationsPorteur () {
      this.$store.dispatch('porteur/getOperationsPorteur', this.rechercheOperationPorteur).then(
        response => {
          this.fileContent = window.atob(response)
          if ('msSaveOrOpenBlob' in navigator) {
            let byteNumbers = new Array(this.fileContent.length)
            for (var i = 0; i < this.fileContent.length; i++) {
              byteNumbers[i] = this.fileContent.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            window.navigator.msSaveOrOpenBlob(new Blob([byteArray]), 'report.txt')
          } else {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = 'data:application/file;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(this.fileContent)
            hiddenElement.target = '_blank'
            hiddenElement.download = 'report.txt'
            document.body.appendChild(hiddenElement)
            hiddenElement.click()
            document.body.removeChild(hiddenElement)
          }
        },
        error => {
          this.errorMessage = error.response.data
        }
      )
    },
    downloadFile (theRapport) {
      this.fileToDownload.login = this.$store.state.user.user.login
      this.fileToDownload.realFileNameToDownload = theRapport.absolutePath
      this.fileToDownload.keyFolder = theRapport.keyFolder
      this.fileToDownload.nomFichier = theRapport.nomFichierTelecharge.substr(1, theRapport.nomFichierTelecharge.length)

      this.$store.dispatch('porteur/downloadRelevesPorteurs', this.fileToDownload).then(
        response => {
          let blob = new Blob([response], { type: 'application/pdf' })

          if ('msSaveOrOpenBlob' in navigator) {
            window.navigator.msSaveOrOpenBlob(blob, this.fileToDownload.nomFichier)
          } else {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = URL.createObjectURL(blob)
            hiddenElement.target = '_blank'
            hiddenElement.download = this.fileToDownload.nomFichier
            document.body.appendChild(hiddenElement)
            hiddenElement.click()
            document.body.removeChild(hiddenElement)
          }
          this.loading = false
        },
        error => {
          this.errorMessage = error.response
          this.loading = false
        }
      )
    },
    getSublist (listToSplit, index, nbElementsToDisplay) {
      return listToSplit.slice((nbElementsToDisplay * index), (nbElementsToDisplay + (nbElementsToDisplay * index)))
    },
    
    // Nouvelle méthode : centralise le chargement
    loadRelevesOperations () {
      this.rechercheOperationPorteur.login = this.$store.state.user.user.login

      if (this.$store.state.user.actualSelectedCard) {
        this.rechercheOperationPorteur.card = this.$store.state.user.actualSelectedCard
        this.rechercheOperationPorteur.currentPersonne = this.$store.state.user.actualSelectedCard.contract.personne
      }

      this.rechercheOperationPorteur.demo = this.$store.state.user.user.groupe.name === 'DemoPorteur'

      this.loading = true
      this.$store.dispatch('porteur/getRelevesOperationsPorteur', this.rechercheOperationPorteur).then(
        response => {
          this.loading = false
          this.listeRapports = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    }
  },
  mounted () {
    let dateDebut = new Date()
    dateDebut.setDate(0)
    let dateFin = new Date()
    this.rechercheOperationPorteur.dateDebut = dateDebut.toISOString().substr(0, 10)
    this.rechercheOperationPorteur.dateFin = dateFin.toISOString().substr(0, 10)

    var self = this
    $( function () {
      $('#datedebut').datepicker({
        onSelect: function (dateText) {
          self.rechercheOperationPorteur.dateDebut = dateText
        }
      })
      $('#datefin').datepicker({
        onSelect: function (dateText) {
          self.rechercheOperationPorteur.dateFin = dateText
        }
      })
    })

    // Chargement initial
    this.loadRelevesOperations()
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Relevés d\'opérations'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
